/* eslint-disable @typescript-eslint/naming-convention */
import { info } from '@ms/yammer-console-logging';

import { getTelemetryClientConfig } from '../../telemetryStore';

import { DecodeableProperties, decodeEventSpecificProperties } from './decodeEventSpecificProperties';
import { loadProtobuf } from './lazyExports';

interface PartiallyDecodedProtobufEvent {
  readonly [key: string]: unknown;
  readonly properties: DecodeableProperties;
}

export const logProtobufEvents = async (events: PartiallyDecodedProtobufEvent[]) => {
  const { shouldLogProtobufEventsToConsole } = getTelemetryClientConfig();

  if (shouldLogProtobufEventsToConsole) {
    const protobuf = await loadProtobuf();
    const decodedEvents = events.map((event) => ({
      ...event,
      properties: decodeEventSpecificProperties(protobuf, event.properties),
    }));

    info('Protobuf encoded analytics events:', decodedEvents);
  }
};
